var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{attrs:{"shadow":"never","body-style":{
      padding: '20px 15px',
    }}},[_c('ProductMaterial',{staticClass:"mb-4",attrs:{"proofingCode":_vm.proofingCode,"disabled":_vm.disabled}}),_c('ProductInfo',{attrs:{"proofingCode":_vm.proofingCode,"disabled":_vm.disabled}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }